<ng-content></ng-content>
<div @fade class="cover" [class.opaque]="_.data_" *ngIf="_.loading">
  <riv-loading [size]="size"></riv-loading>
</div>
<div
  class="cover error"
  *ngIf="!disableErrorCover && _.erred"
  [ngClass]="{ 'row-style': isErrorCoverRowStyle }"
>
  <span class="error-icon">🙁</span>
  <span class="error-message">{{ _.errorMessage_ }}</span>
</div>
